<template>
  <section class="content-menu-tasks">
    <HeaderTitle :title="'Empresas'" :image="'company'" />
    <div class="content-menu-tasks-body">
      <router-link
        :to="{ name: 'RegisterPosition' }"
        class="content-menu-tasks-body--link"
      >
        <p>Registrar Cargo</p>
        <div class="icon">
          <svg
            width="8"
            height="16"
            viewBox="0 0 8 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_20_670)">
              <mask
                id="mask0_20_670"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="0"
                y="1"
                width="8"
                height="15"
              >
                <path
                  d="M0.25 15.5L7.75 15.5L7.75 1.17984L0.25 1.17984L0.25 15.5Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_20_670)">
                <path
                  d="M7.4754 9.06207C7.84153 8.66266 7.84153 8.01398 7.4754 7.61457L1.85149 1.47936C1.48538 1.07995 0.89075 1.07995 0.524625 1.47936C0.158437 1.87884 0.158437 2.52745 0.524625 2.92693L5.48652 8.33989L0.527563 13.7529C0.161375 14.1523 0.161375 14.801 0.527563 15.2004C0.893688 15.5999 1.48831 15.5999 1.85442 15.2004L7.47832 9.06527L7.4754 9.06207Z"
                  fill="black"
                />
              </g>
            </g>
            <defs>
              <clipPath id="clip0_20_670">
                <path
                  d="M7.75 11.75C7.75 13.8211 6.07107 15.5 4 15.5C1.92893 15.5 0.25 13.8211 0.25 11.75L0.25 0.5L7.75 0.5L7.75 11.75Z"
                  fill="white"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
      </router-link>
      <router-link
        :to="{ name: 'ListPositions' }"
        class="content-menu-tasks-body--link"
      >
        <p>Listar Cargos</p>
        <div class="icon">
          <svg
            width="8"
            height="16"
            viewBox="0 0 8 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_20_670)">
              <mask
                id="mask0_20_670"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="0"
                y="1"
                width="8"
                height="15"
              >
                <path
                  d="M0.25 15.5L7.75 15.5L7.75 1.17984L0.25 1.17984L0.25 15.5Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_20_670)">
                <path
                  d="M7.4754 9.06207C7.84153 8.66266 7.84153 8.01398 7.4754 7.61457L1.85149 1.47936C1.48538 1.07995 0.89075 1.07995 0.524625 1.47936C0.158437 1.87884 0.158437 2.52745 0.524625 2.92693L5.48652 8.33989L0.527563 13.7529C0.161375 14.1523 0.161375 14.801 0.527563 15.2004C0.893688 15.5999 1.48831 15.5999 1.85442 15.2004L7.47832 9.06527L7.4754 9.06207Z"
                  fill="black"
                />
              </g>
            </g>
            <defs>
              <clipPath id="clip0_20_670">
                <path
                  d="M7.75 11.75C7.75 13.8211 6.07107 15.5 4 15.5C1.92893 15.5 0.25 13.8211 0.25 11.75L0.25 0.5L7.75 0.5L7.75 11.75Z"
                  fill="white"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
      </router-link>
      <router-link
        :to="{ name: 'RegisterDepartment' }"
        class="content-menu-tasks-body--link"
      >
        <p>Registrar Departamento</p>
        <div class="icon">
          <svg
            width="8"
            height="16"
            viewBox="0 0 8 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_20_670)">
              <mask
                id="mask0_20_670"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="0"
                y="1"
                width="8"
                height="15"
              >
                <path
                  d="M0.25 15.5L7.75 15.5L7.75 1.17984L0.25 1.17984L0.25 15.5Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_20_670)">
                <path
                  d="M7.4754 9.06207C7.84153 8.66266 7.84153 8.01398 7.4754 7.61457L1.85149 1.47936C1.48538 1.07995 0.89075 1.07995 0.524625 1.47936C0.158437 1.87884 0.158437 2.52745 0.524625 2.92693L5.48652 8.33989L0.527563 13.7529C0.161375 14.1523 0.161375 14.801 0.527563 15.2004C0.893688 15.5999 1.48831 15.5999 1.85442 15.2004L7.47832 9.06527L7.4754 9.06207Z"
                  fill="black"
                />
              </g>
            </g>
            <defs>
              <clipPath id="clip0_20_670">
                <path
                  d="M7.75 11.75C7.75 13.8211 6.07107 15.5 4 15.5C1.92893 15.5 0.25 13.8211 0.25 11.75L0.25 0.5L7.75 0.5L7.75 11.75Z"
                  fill="white"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
      </router-link>
      <router-link
        :to="{ name: 'ListDepartments' }"
        class="content-menu-tasks-body--link"
      >
        <p>Listar Departamentos</p>
        <div class="icon">
          <svg
            width="8"
            height="16"
            viewBox="0 0 8 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_20_670)">
              <mask
                id="mask0_20_670"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="0"
                y="1"
                width="8"
                height="15"
              >
                <path
                  d="M0.25 15.5L7.75 15.5L7.75 1.17984L0.25 1.17984L0.25 15.5Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_20_670)">
                <path
                  d="M7.4754 9.06207C7.84153 8.66266 7.84153 8.01398 7.4754 7.61457L1.85149 1.47936C1.48538 1.07995 0.89075 1.07995 0.524625 1.47936C0.158437 1.87884 0.158437 2.52745 0.524625 2.92693L5.48652 8.33989L0.527563 13.7529C0.161375 14.1523 0.161375 14.801 0.527563 15.2004C0.893688 15.5999 1.48831 15.5999 1.85442 15.2004L7.47832 9.06527L7.4754 9.06207Z"
                  fill="black"
                />
              </g>
            </g>
            <defs>
              <clipPath id="clip0_20_670">
                <path
                  d="M7.75 11.75C7.75 13.8211 6.07107 15.5 4 15.5C1.92893 15.5 0.25 13.8211 0.25 11.75L0.25 0.5L7.75 0.5L7.75 11.75Z"
                  fill="white"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
      </router-link>
      <router-link
        :to="{ name: 'RegisterCompanyPlans' }"
        class="content-menu-tasks-body--link"
      >
        <p>Registrar Plano Empresas</p>
        <div class="icon">
          <svg
            width="8"
            height="16"
            viewBox="0 0 8 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_20_670)">
              <mask
                id="mask0_20_670"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="0"
                y="1"
                width="8"
                height="15"
              >
                <path
                  d="M0.25 15.5L7.75 15.5L7.75 1.17984L0.25 1.17984L0.25 15.5Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_20_670)">
                <path
                  d="M7.4754 9.06207C7.84153 8.66266 7.84153 8.01398 7.4754 7.61457L1.85149 1.47936C1.48538 1.07995 0.89075 1.07995 0.524625 1.47936C0.158437 1.87884 0.158437 2.52745 0.524625 2.92693L5.48652 8.33989L0.527563 13.7529C0.161375 14.1523 0.161375 14.801 0.527563 15.2004C0.893688 15.5999 1.48831 15.5999 1.85442 15.2004L7.47832 9.06527L7.4754 9.06207Z"
                  fill="black"
                />
              </g>
            </g>
            <defs>
              <clipPath id="clip0_20_670">
                <path
                  d="M7.75 11.75C7.75 13.8211 6.07107 15.5 4 15.5C1.92893 15.5 0.25 13.8211 0.25 11.75L0.25 0.5L7.75 0.5L7.75 11.75Z"
                  fill="white"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
      </router-link>
      <router-link
        :to="{ name: 'ListCompanyPlans' }"
        class="content-menu-tasks-body--link"
      >
        <p>Listar Planos Empresas</p>
        <div class="icon">
          <svg
            width="8"
            height="16"
            viewBox="0 0 8 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_20_670)">
              <mask
                id="mask0_20_670"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="0"
                y="1"
                width="8"
                height="15"
              >
                <path
                  d="M0.25 15.5L7.75 15.5L7.75 1.17984L0.25 1.17984L0.25 15.5Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_20_670)">
                <path
                  d="M7.4754 9.06207C7.84153 8.66266 7.84153 8.01398 7.4754 7.61457L1.85149 1.47936C1.48538 1.07995 0.89075 1.07995 0.524625 1.47936C0.158437 1.87884 0.158437 2.52745 0.524625 2.92693L5.48652 8.33989L0.527563 13.7529C0.161375 14.1523 0.161375 14.801 0.527563 15.2004C0.893688 15.5999 1.48831 15.5999 1.85442 15.2004L7.47832 9.06527L7.4754 9.06207Z"
                  fill="black"
                />
              </g>
            </g>
            <defs>
              <clipPath id="clip0_20_670">
                <path
                  d="M7.75 11.75C7.75 13.8211 6.07107 15.5 4 15.5C1.92893 15.5 0.25 13.8211 0.25 11.75L0.25 0.5L7.75 0.5L7.75 11.75Z"
                  fill="white"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
      </router-link>
      <router-link
        :to="{ name: 'RegisterCompany' }"
        class="content-menu-tasks-body--link"
      >
        <p>Registrar Empresa</p>
        <div class="icon">
          <svg
            width="8"
            height="16"
            viewBox="0 0 8 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_20_670)">
              <mask
                id="mask0_20_670"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="0"
                y="1"
                width="8"
                height="15"
              >
                <path
                  d="M0.25 15.5L7.75 15.5L7.75 1.17984L0.25 1.17984L0.25 15.5Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_20_670)">
                <path
                  d="M7.4754 9.06207C7.84153 8.66266 7.84153 8.01398 7.4754 7.61457L1.85149 1.47936C1.48538 1.07995 0.89075 1.07995 0.524625 1.47936C0.158437 1.87884 0.158437 2.52745 0.524625 2.92693L5.48652 8.33989L0.527563 13.7529C0.161375 14.1523 0.161375 14.801 0.527563 15.2004C0.893688 15.5999 1.48831 15.5999 1.85442 15.2004L7.47832 9.06527L7.4754 9.06207Z"
                  fill="black"
                />
              </g>
            </g>
            <defs>
              <clipPath id="clip0_20_670">
                <path
                  d="M7.75 11.75C7.75 13.8211 6.07107 15.5 4 15.5C1.92893 15.5 0.25 13.8211 0.25 11.75L0.25 0.5L7.75 0.5L7.75 11.75Z"
                  fill="white"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
      </router-link>
      <router-link
        :to="{ name: 'ListCompanies' }"
        class="content-menu-tasks-body--link"
      >
        <p>Listar Empresas</p>
        <div class="icon">
          <svg
            width="8"
            height="16"
            viewBox="0 0 8 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_20_670)">
              <mask
                id="mask0_20_670"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="0"
                y="1"
                width="8"
                height="15"
              >
                <path
                  d="M0.25 15.5L7.75 15.5L7.75 1.17984L0.25 1.17984L0.25 15.5Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_20_670)">
                <path
                  d="M7.4754 9.06207C7.84153 8.66266 7.84153 8.01398 7.4754 7.61457L1.85149 1.47936C1.48538 1.07995 0.89075 1.07995 0.524625 1.47936C0.158437 1.87884 0.158437 2.52745 0.524625 2.92693L5.48652 8.33989L0.527563 13.7529C0.161375 14.1523 0.161375 14.801 0.527563 15.2004C0.893688 15.5999 1.48831 15.5999 1.85442 15.2004L7.47832 9.06527L7.4754 9.06207Z"
                  fill="black"
                />
              </g>
            </g>
            <defs>
              <clipPath id="clip0_20_670">
                <path
                  d="M7.75 11.75C7.75 13.8211 6.07107 15.5 4 15.5C1.92893 15.5 0.25 13.8211 0.25 11.75L0.25 0.5L7.75 0.5L7.75 11.75Z"
                  fill="white"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
      </router-link>
      <router-link
        :to="{ name: 'RegisterLeadStatus' }"
        class="content-menu-tasks-body--link"
      >
        <p>Registrar Leads Status</p>
        <div class="icon">
          <svg
            width="8"
            height="16"
            viewBox="0 0 8 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_20_670)">
              <mask
                id="mask0_20_670"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="0"
                y="1"
                width="8"
                height="15"
              >
                <path
                  d="M0.25 15.5L7.75 15.5L7.75 1.17984L0.25 1.17984L0.25 15.5Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_20_670)">
                <path
                  d="M7.4754 9.06207C7.84153 8.66266 7.84153 8.01398 7.4754 7.61457L1.85149 1.47936C1.48538 1.07995 0.89075 1.07995 0.524625 1.47936C0.158437 1.87884 0.158437 2.52745 0.524625 2.92693L5.48652 8.33989L0.527563 13.7529C0.161375 14.1523 0.161375 14.801 0.527563 15.2004C0.893688 15.5999 1.48831 15.5999 1.85442 15.2004L7.47832 9.06527L7.4754 9.06207Z"
                  fill="black"
                />
              </g>
            </g>
            <defs>
              <clipPath id="clip0_20_670">
                <path
                  d="M7.75 11.75C7.75 13.8211 6.07107 15.5 4 15.5C1.92893 15.5 0.25 13.8211 0.25 11.75L0.25 0.5L7.75 0.5L7.75 11.75Z"
                  fill="white"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
      </router-link>
      <router-link
        :to="{ name: 'ListLeadsStatus' }"
        class="content-menu-tasks-body--link"
      >
        <p>Listar Leads Status</p>
        <div class="icon">
          <svg
            width="8"
            height="16"
            viewBox="0 0 8 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_20_670)">
              <mask
                id="mask0_20_670"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="0"
                y="1"
                width="8"
                height="15"
              >
                <path
                  d="M0.25 15.5L7.75 15.5L7.75 1.17984L0.25 1.17984L0.25 15.5Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_20_670)">
                <path
                  d="M7.4754 9.06207C7.84153 8.66266 7.84153 8.01398 7.4754 7.61457L1.85149 1.47936C1.48538 1.07995 0.89075 1.07995 0.524625 1.47936C0.158437 1.87884 0.158437 2.52745 0.524625 2.92693L5.48652 8.33989L0.527563 13.7529C0.161375 14.1523 0.161375 14.801 0.527563 15.2004C0.893688 15.5999 1.48831 15.5999 1.85442 15.2004L7.47832 9.06527L7.4754 9.06207Z"
                  fill="black"
                />
              </g>
            </g>
            <defs>
              <clipPath id="clip0_20_670">
                <path
                  d="M7.75 11.75C7.75 13.8211 6.07107 15.5 4 15.5C1.92893 15.5 0.25 13.8211 0.25 11.75L0.25 0.5L7.75 0.5L7.75 11.75Z"
                  fill="white"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
      </router-link>
      <router-link
        :to="{ name: 'Leads' }"
        class="content-menu-tasks-body--link"
      >
        <p>Listar Leads</p>
        <div class="icon">
          <svg
            width="8"
            height="16"
            viewBox="0 0 8 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_20_670)">
              <mask
                id="mask0_20_670"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="0"
                y="1"
                width="8"
                height="15"
              >
                <path
                  d="M0.25 15.5L7.75 15.5L7.75 1.17984L0.25 1.17984L0.25 15.5Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_20_670)">
                <path
                  d="M7.4754 9.06207C7.84153 8.66266 7.84153 8.01398 7.4754 7.61457L1.85149 1.47936C1.48538 1.07995 0.89075 1.07995 0.524625 1.47936C0.158437 1.87884 0.158437 2.52745 0.524625 2.92693L5.48652 8.33989L0.527563 13.7529C0.161375 14.1523 0.161375 14.801 0.527563 15.2004C0.893688 15.5999 1.48831 15.5999 1.85442 15.2004L7.47832 9.06527L7.4754 9.06207Z"
                  fill="black"
                />
              </g>
            </g>
            <defs>
              <clipPath id="clip0_20_670">
                <path
                  d="M7.75 11.75C7.75 13.8211 6.07107 15.5 4 15.5C1.92893 15.5 0.25 13.8211 0.25 11.75L0.25 0.5L7.75 0.5L7.75 11.75Z"
                  fill="white"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
      </router-link>
    </div>
  </section>
</template>

<script>
import HeaderTitle from "@/components/headers/HeaderTitle";

export default {
  components: {
    HeaderTitle,
  },
};
</script>
